import script from "./Paper.vue?vue&type=script&setup=true&lang=ts"
export * from "./Paper.vue?vue&type=script&setup=true&lang=ts"

import "./Paper.vue?vue&type=style&index=0&id=683c33b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683c33b7"]])

export default __exports__